import React from 'react';
import uuid from 'uuid-random';
import { styled } from '@mui/system';
import Tooltip from '@mui/material/Tooltip';
import FacebookIcon from 'assets/icons/facebook.svg?react';
import InstagramIcon from 'assets/icons/instagram.svg?react';
import TikTokIcon from 'assets/icons/tikTok.svg?react';
import TwitterIcon from 'assets/icons/twitter.svg?react';
import YouTubeIcon from 'assets/icons/youTube.svg?react';
import SiteInIcon from 'assets/icons/tabler_world-www.svg?react';
import TelegramIcon from 'assets/icons/telegram.svg?react';
import fixNotValidUrl from 'helpers/fixNotValidUrl';

const SocialMediaWrapper = styled('div')(() => ({
  display: 'flex',
  gap: 24
}));

const getType = (url = '') => {
  if (url.includes('facebook')) {
    return 'facebook';
  }
  if (url.includes('instagram')) {
    return 'instagram';
  }
  if (url.includes('tiktok')) {
    return 'tiktok';
  }
  if (url.includes('x.com')) {
    return 'twitter';
  }
  if (url.includes('youtube')) {
    return 'youtube';
  }
  if (url.includes('t.me')) {
    return 'telegram';
  }
  return 'site';
};

const SocialMedia = ({ list, callBack }) => {
  const iconMap = React.useMemo(
    () => ({
      facebook: FacebookIcon,
      instagram: InstagramIcon,
      tiktok: TikTokIcon,
      twitter: TwitterIcon,
      youtube: YouTubeIcon,
      telegram: TelegramIcon,
      default: SiteInIcon
    }),
    []
  );

  const RenderLink = React.useCallback(
    ({ url }) => {
      const type = getType(url);
      const IconComponent = iconMap[type] || iconMap.default;

      return (
        <a
          href={fixNotValidUrl(url)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            callBack && callBack();
          }}>
          <Tooltip title={fixNotValidUrl(url)}>
            <IconComponent />
          </Tooltip>
        </a>
      );
    },
    [iconMap, callBack]
  );

  if (Array.isArray(list)) {
    return (
      <SocialMediaWrapper>
        {[]
          .concat(list)
          .filter(Boolean)
          .map(({ website, web }) => {
            return <RenderLink key={uuid()} url={website || web} />;
          })}
      </SocialMediaWrapper>
    );
  }

  return (
    <SocialMediaWrapper>
      {Object.values(list || {})
        .filter(Boolean)
        .map((website) => {
          return <RenderLink key={uuid()} url={website} />;
        })}
    </SocialMediaWrapper>
  );
};

export { getType };

export default SocialMedia;
